// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_2momGgnuRvlq8L81UenurH"};